import OrderableModel from '@/models/OrderableModel';

export default class PrepaidCard extends OrderableModel {
    get route () {
        return 'prepaid-cards';
    }

    static get className () {
        return 'PrepaidCard';
    }

    static get isInStore () {
        return true;
    }
}
